import { Claim } from "../admin/models/claim.model"
import { SignerType } from "../admin/models/contact.model";

export class UserIdentity {

    // public static getAnonymousIdentity() {
    //     return new UserIdentity([], false);
    // }

    allClaims: Claim[] = [];
    associatedOrganizations: string[] = [];
    canLogin: boolean;
    dashboards?: string[] = [];
    displayName: string;
    email: string;
    groups: string[] = [];
    id: string;
    isInternal: boolean;
    isLoggedIn: boolean;
    organizationId: string;
    systemPermissions?: string[] = [];
    widgetPermissions?: string[] = [];
	workflowPermissions?: string[] = [];

	get rbdmsOwnerNumber(): string {
		if (this.allClaims == null || this.allClaims.length == 0) return "";
		let rbdmsClaim = this.allClaims.find(c => c.type == LunaClaimTypes.RBDMSOwnerNumber);
		if (rbdmsClaim == null) return "";
		return rbdmsClaim.value;
	}
  

    constructor(claims: Claim[], email: string, isLoggedIn: boolean) {
        this.allClaims = claims;
        const idClaims = claims.filter(c => c.type == LunaClaimTypes.UserId);
        this.id = idClaims.length > 0 ? idClaims[0].value : "";

        const displayNameClaims = claims.filter(c => c.type == LunaClaimTypes.DisplayName);
        this.displayName = displayNameClaims.length > 0 ? displayNameClaims[0].value : "";

        this.email = email;         
        this.associatedOrganizations = claims.filter(c => c.type == LunaClaimTypes.Organization).map(c => c.value);

        this.canLogin = claims.filter(c => c.type == LunaClaimTypes.CanLogIn && c.value == LunaClaimValues.True).length > 0;
        this.dashboards = claims.filter(c => c.type == LunaClaimTypes.Dashboard).map(c => c.value);
        this.groups = claims.filter(c => c.type == LunaClaimTypes.Group).map(c => c.value);
        this.isInternal = claims.filter(c => c.type == LunaClaimTypes.IsInternal && c.value == LunaClaimValues.True).length > 0;

        for (let x = 0; x < claims.length; x++) {
            if (claims[x].type == LunaClaimTypes.System && this.systemPermissions.filter(a => a == claims[x].value).length <= 0) {
                this.systemPermissions.push(claims[x].value);
            }

            if (claims[x].type == LunaClaimTypes.Widget && this.widgetPermissions.filter(a => a == claims[x].value).length <= 0) {
                this.widgetPermissions.push(claims[x].value);
            }
        }

        //this.systemPermissions = claims.filter(c => c.type == LunaClaimTypes.System).map(c => c.value);
        //this.widgetPermissions = claims.filter(c => c.type == LunaClaimTypes.Widget).map(c => c.value);

        this.isLoggedIn = isLoggedIn;
    }

    get authority(): string {
        if (this.hasPermission(LunaClaimTypes.System, LunaClaimValues.ChiefAuthority)) return LunaClaimValues.ChiefAuthority;
        if (this.hasPermission(LunaClaimTypes.System, LunaClaimValues.AssistantChiefAuthority)) return LunaClaimValues.AssistantChiefAuthority;
        if (this.hasPermission(LunaClaimTypes.System, LunaClaimValues.DeputyAuthority)) return LunaClaimValues.DeputyAuthority;
        return SignerType.None;
    }

    get defaultDashboard(): string {
        console.log(`get defaultDashboad() this.isLoggedIn: ${this.isLoggedIn}`);
        if (!this.isLoggedIn) return null;
        const found = this.findPermissions(LunaClaimTypes.DefaultDashboard, null).map(c => c.value);
        console.log(`default dashboards: ${found.join(', ')}`)
        if (found.length > 0) {
            return found[0];
        }
        const fallbackDashboard = this.isInternal ? "ricsDashboard" : "external_default";
        console.log(`no default dashboard claim found falling back to ${fallbackDashboard}`);
        return fallbackDashboard;
    }

    get isAnonymous(): boolean {
        if (!this.isLoggedIn) return true;
        const anon = this.allClaims.find(cl => cl.type === "anon" || cl.value === "anon");
        return (anon != null);
    }

    get notInRICS(): boolean {
        const notClaim = this.allClaims.find(cl => cl.type === "notinrics" || cl.value === "notinrics");
        return notClaim != null;
    }

    findPermissions(type: string, value: string | null): Claim[] {
        return this.allClaims.filter(c => c.type === type && (value === null || c.value === value));
    }

    hasPermission(type: string, value: string | null): boolean {
        return this.findPermissions(type, value).length > 0;
    }
    
}

export enum LunaClaimTypes {
    Group = "group",
    WorkflowAction = "wf_act",
    Organization = "org",
    UserId = "sub",
    DisplayName = "display_name",
    Anonymous = "anon",
    WorkflowInitialize = "wf_ini",
    Dashboard = "dash",
    DefaultDashboard = "defdash",
    Widget = "widget",
    Authenticated = "auth",
    IsInternal = "internal",
    System = "sys_perm",
    CanLogIn = "canLogIn",
    ReminderManager = "notiman",
    CanForceReminderExecution = "force_pol",
    CertifiedMail = "certmail",
	RICSUserId = "ricsuserid",
	RBDMSOwnerNumber = "rbdmsOwner"
}
export class LunaClaimValues {

    static readonly True: string = "y";
    static readonly False: string = "n";
    static readonly None: string = "nil";
    static readonly Anonymous: string = "anon";

    // System claims
    // ---------------------------------------------------------
    //Edit Specific Fields on a well
    static readonly EditWellTypeDescription: string = "edit_well_type_description";
    static readonly EditWellDispositionLegacyTracking: string = "edit_well_disposition_legacyTracking";
    // Admin
    static readonly ManageModules: string = "manage_module";
    static readonly ManageContacts: string = "manage_contact";
    static readonly LockUnlockContact: string = "lock_contact"
    static readonly EditContact: string = "edit_contact";
    static readonly ManageContactsLimited: string = "manage_contact_limited";
	static readonly ManageGroups: string = "manage_group";
	static readonly ManageSystemSettings: string = "manage_system_settings";
	static readonly ManageFees: string = "manage_fees";
    static readonly InitiateDataCorrection = "initiate_DataCorrection";
    static readonly ApproveBulkWellStatusChanges = "approve_bulkWellStatusChanges";
    static readonly ManageCommunications = "manage_communications";
    static readonly InitiateCommunications = "initiate_communications";
    
    static readonly RequestDocumentScanning = "request_scanning";
    static readonly OnBaseManagement = "onbase_management";
    static readonly LandOwnerPassThroughProgram = "landowner_passthrough";
    static readonly ApproveLandownerPassthroughProgramApplication = "approve_landowner_passthrough";
    static readonly ReserveAPINumber = "reserve_API";
    static readonly ApprovePaymentAdjustments = "approve_payment_adjustments";
    static readonly ViewApplicationLog = "view_application_log";
    static readonly ViewSystemAlerts = "view_system_alerts";
	static readonly CanDeleteApiNumbers = "delete_api_numbers";
	static readonly BulkUploadNAD83LatLong = "bulk_upload_nad83";
	static readonly ApproveBulkUploadNad83LatLong = "approve_bulk_upload_nad83";

    // Builder
    static readonly ManageWorkflows: string = "manage_workflow";
    // Common
    static readonly ManageDashboards: string = "manage_dash";
    static readonly ManageLawLibrary: string = "manage_law";
    static readonly ManageAnyOrganization: string = "manage_any_org";
    static readonly ManageOwnOrganization: string = "manage_own_org";
    static readonly CanEditOrganization: string = "can_edit_org";
    static readonly ManageOwnContact: string = "manage_own_contact";
    static readonly ManageWorkOrders: string = "manage_workorder";
    static readonly ManageIssues: string = "manage_issue";
    static readonly ApproveIssueEscalation: string = "approve_issue_escalation";
    static readonly PaymentReport: string = "payment_report";
    static readonly SuretyReport: string = "surety_report";
    static readonly ContactHistoryReport: string = "contact_history_report";
    static readonly FileUploadHistoryReport: string = "file_upload_history_report";
    static readonly InsuranceFullDataListReport: string = "insurance_full_list_report";
    static readonly InsuranceComplianceByDateReport: string = "insurance_compliance_by_date_report";
    static readonly ManageInspectorList: string = "manage_inspectors";
    static readonly RegeneratePermits: string = "regenerate_permits";
    static readonly ManageTemplates: string = "manage_tmplt";
    static readonly EditLetterStatus: string = "edit_letter_status";
    static readonly ApproveAdhocScans: string = "approve_adhoc_scan";
    static readonly ViewUserPermissionsReport: string = "view_user_permissions_report";
    static readonly CanEditWellDetails: string = "edit_well_details";
    static readonly ViewAllWellsRequiringBondingInsuranceReport: string = "view_bonding_insurance_report";

    //Chief's Orders
    static readonly ManageInProgressChiefOrders: string = "manage_ipco";
    static readonly ManuallySetChiefsOrderStatus: string = "can_manually_set_chiefsOrder_status";
    


    // Notifications
    static readonly ManageReminders: string = "manage_reminders";
    // Entity Builder
    static readonly ManageEntities: string = "manage_entity";
    // Document Management
    static readonly DocumentManagement: string = "docmgmt";

    static readonly ReadLawLibrary: string = "read_law";

    // Widget claims
    // ---------------------------------------------------------
    static readonly ViewChartWidget: string = "view_chart";
    static readonly ViewGridWidget: string = "view_grid";
    static readonly ViewMapWidget: string = "view_map";
    static readonly ViewWorkOrderWidget: string = "view_workOrder";
    static readonly ViewFullCalendarWidget: string = "view_fullCalender";
    static readonly ViewListCalendarWidget: string = "view_listCalendar";
    static readonly ViewRegistrationRequestWidget: string = "view_registrationRequest";
    static readonly ViewPermitsWidget: string = "view_permits";
    static readonly ViewFinancialAssuranceWidget: string = "view_financialAssurance";
    static readonly ViewExternalPermitWidget: string = "view_externalPermit";
    static readonly ViewExternalWorkOrderWidget: string = "view_externalWorkOrder";
    static readonly ViewPendingMailWidget: string = "view_pendingMail";
    static readonly ViewScanningWidget: string = "view_scanning";
    static readonly ViewFinancialAssuranceInternalWidget: string = "view_financialAssuranceInternal";
    static readonly ViewPendingPaymentsWidget: string = "view_pendingPayments";
    static readonly ViewWellsWidget: string = "view_wells";
    static readonly ViewExternalChiefsOrdersStatusWidget: string = "view_chiefsorders_status";
    static readonly ViewOrgFilesWidget: string = "view_orgFiles";
    static readonly ViewExternalUpcomingBondExpirationsWidget:string = "view_bondexpiration_ext";
    static readonly ViewInternalUpcomingBondExpirationsWidget:string = "view_bondexpiration_int";

    static readonly ViewInternalUpcomingInsurancePolicyExpirationsWidget: string = "view_insurancePolicyExpiration_int";

    static readonly ViewPendingWellTransferWidget = "view_pendingWellTransfer";
    static readonly ViewWellSellerTransferWidget = "view_wellSellerTransfer";
    static readonly ViewInternalInspectionsWidget = "view_internal_inspections";
    static readonly ViewWellBuyerTransferWidget = "view_wellBuyerTransfer";
    static readonly ViewExternalPaymentsWidget = "view_externalPayments";
    static readonly ViewNotificationsWidget = "view_notifications";

    static readonly ViewUtilityWidget: string = "view_utility";
    static readonly ViewExternal7ATransferWidget: string = "view_external_7a";
    static readonly ViewIssuesWidget = "view_issues";
    static readonly ViewExternalIssuesWidget = "view_issues_external";
    static readonly ViewDataCorrectionsWidget = "view_dataCorrections";
    static readonly ViewExternalDataCorrectionRequestsWidget = "view_externalDataCorrectionRequests";
    static readonly ViewInternalDataCorrectionRequestsWidget = "view_internalDataCorrectionRequests";
    static readonly ViewPaperSubmissionsWidget = "view_paperSubmissions";
    static readonly ViewInternalComplianceReportWidget = "view_internalComplianceReport";
    static readonly ViewExternalComplianceReportWidget = "view_externalComplianceReport";
    static readonly ViewWellSearchWidget = "view_wellSearch";
    static readonly InitiateEDiscovery = "initiate_eDiscovery";

    static readonly ViewHelpLibrary = "view_helpLibrary";
    static readonly EditHelpLibrary = "edit_helpLibrary";

    static readonly ExecuteFlowOnBehalf = "onBehalf_flow";
    static readonly ExecutePermitFlowOnBehalf = "onBehalf_permit";
    static readonly ExecuteFAFlowOnBehalf = "onBehalf_fa";
    static readonly ExecuteWellTransferOnBehalf = "onBehalf_transfer";
    static readonly ExecuteRegistrationOnBehalf = "onBehalf_registration";

    static readonly ViewExternalOrganizationManagementWidget = "view_externalOrganizationManagement";
    static readonly ViewInternalOrganizationManagementWidget = "view_internalOrganizationManagement";
    static readonly ViewLandownerPassthroughWidget = "view_landowner_passthrough";

    // Authorities
    static readonly ChiefAuthority: string = "Chief";
    static readonly AssistantChiefAuthority: string = "Assistant Chief";
    static readonly DeputyAuthority: string = "Deputy";

    //Financial Assurance
    static readonly CanAddBonding = "can_add_bonding";
    static readonly CanAddInsurance = "can_add_insurance";

    //Permitting
    static readonly ManagePermits = "manage_permits";

    //Issues
    static readonly SubmitComplianceReport = "can_report_compliance";
    static readonly ReviewComplianceReport = "can_review_compliance";
    static readonly ViewComplianceReport: string = "can_view_complianceReport"

    //'Streamlined' application types
    static readonly PrepareStratigraphicWellApplication = "prepare_stratigraphic_wells";
    static readonly SubmitStratigraphicWellApplication = "submit_stratigraphic_wells";
    static readonly ReviewStratigraphicWellApplication = "review_stratigraphic_wells";
    static readonly CanUpdateStratigraphicWellBondingRequirements = "update_stratigraphic_well_bonding_requirements";
    
    static workflowAction(workflowId: string, stateName: string, transitionName: string): string {
        return `wfp:${workflowId};${stateName};${transitionName}`;
    }
    static isClaimForWorkflow(type: string, value: string, workflowId: string): boolean {
        return (type == LunaClaimTypes.WorkflowAction && value.indexOf(`wfp:{workflowId}`) == 0) || (
            type == LunaClaimTypes.WorkflowInitialize && value == workflowId);
    }


}
